import { useEffect, useMemo, useState } from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { useAnalytics } from '@chordcommerce/gatsby-theme-autonomy'
import { useAria } from '~/hooks/components/use-aria'
import * as actions from '~/redux/actions/cart-flyout'
import { getIsCartFlyoutOpen } from '~/redux/selectors/cart-flyout'

export function useCartFlyout() {
  const { trackCartViewed } = useAnalytics()
  const { updateAriaLive } = useAria()
  const dispatch = useDispatch()
  const [flyoutTrigger, setFlyoutTrigger] = useState(null)

  const isCartFlyoutOpen = useSelector(getIsCartFlyoutOpen)

  const _closeCartFlyout = useMemo(
    () => bindActionCreators(actions.closeCartFlyout, dispatch),
    [dispatch]
  )

  const _openCartFlyout = useMemo(
    () => bindActionCreators(actions.openCartFlyout, dispatch),
    [dispatch]
  )

  const closeCartFlyout = async () => {
    try {
      await _closeCartFlyout()
      updateAriaLive('Shopping cart closed.')
    } catch (error) {}
  }

  const openCartFlyout = async (trigger) => {
    try {
      await _openCartFlyout()
      if (trigger) setFlyoutTrigger(trigger)
      document?.getElementById('flyout-close-button')?.focus()
      updateAriaLive('Shopping cart opened.')
      trackCartViewed()
    } catch (error) {
      console.error(error, {
        source: 'cartFlyoutMiddleware.cartFlyoutOpen',
      })
    }
  }

  const toggleCartFlyout = useMemo(
    () => bindActionCreators(actions.toggleCartFlyout, dispatch),
    [dispatch]
  )

  useEffect(() => {
    if (!isCartFlyoutOpen && flyoutTrigger) flyoutTrigger?.current?.focus()
  }, [flyoutTrigger, isCartFlyoutOpen])

  return {
    closeCartFlyout,
    isCartFlyoutOpen,
    openCartFlyout,
    toggleCartFlyout,
  }
}
